export default __webpack_public_path__ + "media/transfer-bubble/icon-info-49e8bdff.svg";